// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reviewsio-connect {
  width: 100%;
  margin-left: 1.25rem;
  margin-top: 1.25rem;
}

.reviewsio-connect-banner {
  background-image: url('https://cdn.boostcommerce.io/assets/third-party-integration/Banner background - Boost x Reviewsio.png');
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover; /* Resize the background image to cover the entire container */
  width: 100%;
  padding: 16px;
  display: grid;
  grid-template-columns: 3% 96% 1%;
  margin-left: 0;
  margin-top: 0;
}

.reviewsio-connect-banner.layout-section {
  margin-left: 1.25rem;
  margin-top: 1.25rem;
}

.reviewsio-connect-banner.three-items {
  grid-template-columns: 3% 96% 1%;
}
.reviewsio-connect-banner.three-items-with-button {
  grid-template-columns: 3% 83% 14%;

}
.reviewsio-connect-banner.four-items {
  grid-template-columns: 3% 93% 3% 1%;
}

.reviewsio-connect-banner p {
  font-weight: 600;
}

.reviewsio-connect-banner .action-close:hover {
  cursor: pointer;
}

.reviewsio-connect-banner .banner-button {
  font-weight: 400;
  color: rgba(44, 110, 203, 1);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
}

.reviewsio-connect-banner .banner-button:hover {
  cursor: pointer;
}.BC-Page__Integration .BC-Page__Integration__Content .BC-Default-Card {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.BC-Page__Integration .BC-Page__Integration__Content .item {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 0 0 1px rgba(63, 63, 68, 0.05), 0 1px 3px 0 rgba(63, 63, 68, 0.15);
  min-height: 222px;
  position: relative;
  width: 100%;
  padding: 16px;
  /* Sync height for all items.  */
  height: 100%;
  height: -webkit-fill-available;
  height: -moz-available;
}

.BC-Page__Integration .BC-Page__Integration__Content .item-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.BC-Page__Integration .BC-Page__Integration__Content .Polaris-Link {
  display: inline-block;
}

.BC-Page__Integration .BC-Page__Integration__Content .icon {
  width: 40px;
  border-radius: 8px;
}

.BC-Page__Integration .BC-Page__Integration__Content .name {
  font-size: 1rem;
  font-weight: 700;
  padding-bottom: 8px;
}

.BC-Page__Integration .BC-Page__Integration__Content .integration .Polaris-Badge--statusInfo {
  background-color: #FFF1F3 !important;
}

.BC-Page__Integration .BC-Page__Integration__Content .integration .Polaris-Badge>span {
  display: flex;
  align-items: center;
  gap: 4px;
}

.BC-Page__Integration .BC-Page__Integration__Content .integration .Polaris-Badge .Polaris-Link {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  text-decoration: none;
}


.BC-Page__Integration .BC-Page__Integration__Content .integration .Polaris-Badge .Polaris-Link .Polaris-Icon {
  margin: 0;
  width: 14px;
  height: 14px;
  fill: #00527C;
}


.BC-Page__Integration .BC-Page__Integration__Content .integration.integration--partner>span {
  color: #C11574;
  font-size: 12px;
}

.BC-Page__Integration .BC-Page__Integration__Content .third-party-info.clickable {
  cursor: pointer;
}
.BC-Page__Integration .BC-Page__Integration__Content .third-party-info.clickable:hover .name {
  text-decoration: underline;
}

.BC-Page__Integration .BC-Page__Integration__Content .description {
  font-size: 14px;
  color: #637381;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-bottom: 24px;
  min-height: 40px;
}

.BC-Page__Integration .BC-Page__Integration__Content .instruction {
  font-size: 0.75rem;
  color: #637381;
  line-height: 1rem;
  min-height: 48px;
}


.BC-Page__Integration .BC-Page__Integration__Content .btn-configure .Polaris-Button {
  padding: 3px 12px;
  min-height: 24px;
}

.BC-Page__Integration .BC-Page__Integration__Content .btn-submit {
  margin-top: 12px;
}


.BC-Page__Integration .BC-Page__Integration__Content .BC-Checkbox-Status__Wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  min-height: 28px;
}

.BC-Page__Integration .BC-Page__Integration__Content .BC-Checkbox-Status__Wrapper .BC-Checkbox-Status {
  margin: 0;
}


.BC-Page__Integration .BC-Page__Integration__Content .BC-Checkbox-Status__Wrapper .Polaris-Badge {
  background-color: #E0F0FF !important;
  color: #00527C;
}

.BC-Page__Integration .BC-Page__Integration__Content .BC-Checkbox-Status__Wrapper .BC-Checkbox-Status {
  height: 20px;
  width: 42px;
}

.BC-Page__Integration .BC-Page__Integration__Content .BC-Checkbox-Status__Wrapper .BC-Checkbox-Status span::before {
  height: 20px;
  width: 20px;
}

.BC-Page__Integration .BC-Page__Integration__Content .BC-Checkbox-Status__Wrapper .BC-Checkbox-Status input:checked + span::before {
  transform: translateX(8px);
}

.BC-Page__Integration .BC-Page__Integration__Content .Polaris-FormLayout {
  margin: 0;
  margin-bottom: 8px;
  margin-top: -8px;
}

.BC-Page__Integration .BC-Page__Integration__Content .Polaris-FormLayout .Polaris-FormLayout__Item {
  margin: 0;
}

.BC-Page__Integration .BC-Page__Integration__Pagination {
  display: flex;
  justify-content: center;
  margin-top: 24px;
}

.reviewsio-banner .Polaris-Link {
  text-decoration: underline;
  color: var(--p-interactive);
}

.BC-ModalAppKey .description {
  margin-bottom: 16px;
}`, "",{"version":3,"sources":["webpack://./src/styles/third-party-integration.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,8HAA8H;EAC9H,2BAA2B,EAAE,qBAAqB;EAClD,4BAA4B,EAAE,4BAA4B;EAC1D,sBAAsB,EAAE,8DAA8D;EACtF,WAAW;EACX,aAAa;EACb,aAAa;EACb,gCAAgC;EAChC,cAAc;EACd,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;;AAEnC;AACA;EACE,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB,CAAC;EACC,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gFAAgF;EAChF,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gCAAgC;EAChC,YAAY;EACZ,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;AACvB;;;AAGA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;;AAGA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;;AAGA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;;AAGA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".reviewsio-connect {\n  width: 100%;\n  margin-left: 1.25rem;\n  margin-top: 1.25rem;\n}\n\n.reviewsio-connect-banner {\n  background-image: url('https://cdn.boostcommerce.io/assets/third-party-integration/Banner background - Boost x Reviewsio.png');\n  background-position: center; /* Center the image */\n  background-repeat: no-repeat; /* Do not repeat the image */\n  background-size: cover; /* Resize the background image to cover the entire container */\n  width: 100%;\n  padding: 16px;\n  display: grid;\n  grid-template-columns: 3% 96% 1%;\n  margin-left: 0;\n  margin-top: 0;\n}\n\n.reviewsio-connect-banner.layout-section {\n  margin-left: 1.25rem;\n  margin-top: 1.25rem;\n}\n\n.reviewsio-connect-banner.three-items {\n  grid-template-columns: 3% 96% 1%;\n}\n.reviewsio-connect-banner.three-items-with-button {\n  grid-template-columns: 3% 83% 14%;\n\n}\n.reviewsio-connect-banner.four-items {\n  grid-template-columns: 3% 93% 3% 1%;\n}\n\n.reviewsio-connect-banner p {\n  font-weight: 600;\n}\n\n.reviewsio-connect-banner .action-close:hover {\n  cursor: pointer;\n}\n\n.reviewsio-connect-banner .banner-button {\n  font-weight: 400;\n  color: rgba(44, 110, 203, 1);\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 16px;\n}\n\n.reviewsio-connect-banner .banner-button:hover {\n  cursor: pointer;\n}.BC-Page__Integration .BC-Page__Integration__Content .BC-Default-Card {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n}\n\n.BC-Page__Integration .BC-Page__Integration__Content .item {\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 0 0 1px rgba(63, 63, 68, 0.05), 0 1px 3px 0 rgba(63, 63, 68, 0.15);\n  min-height: 222px;\n  position: relative;\n  width: 100%;\n  padding: 16px;\n  /* Sync height for all items.  */\n  height: 100%;\n  height: -webkit-fill-available;\n  height: -moz-available;\n}\n\n.BC-Page__Integration .BC-Page__Integration__Content .item-header {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.BC-Page__Integration .BC-Page__Integration__Content .Polaris-Link {\n  display: inline-block;\n}\n\n.BC-Page__Integration .BC-Page__Integration__Content .icon {\n  width: 40px;\n  border-radius: 8px;\n}\n\n.BC-Page__Integration .BC-Page__Integration__Content .name {\n  font-size: 1rem;\n  font-weight: 700;\n  padding-bottom: 8px;\n}\n\n.BC-Page__Integration .BC-Page__Integration__Content .integration .Polaris-Badge--statusInfo {\n  background-color: #FFF1F3 !important;\n}\n\n.BC-Page__Integration .BC-Page__Integration__Content .integration .Polaris-Badge>span {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.BC-Page__Integration .BC-Page__Integration__Content .integration .Polaris-Badge .Polaris-Link {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  text-decoration: none;\n}\n\n\n.BC-Page__Integration .BC-Page__Integration__Content .integration .Polaris-Badge .Polaris-Link .Polaris-Icon {\n  margin: 0;\n  width: 14px;\n  height: 14px;\n  fill: #00527C;\n}\n\n\n.BC-Page__Integration .BC-Page__Integration__Content .integration.integration--partner>span {\n  color: #C11574;\n  font-size: 12px;\n}\n\n.BC-Page__Integration .BC-Page__Integration__Content .third-party-info.clickable {\n  cursor: pointer;\n}\n.BC-Page__Integration .BC-Page__Integration__Content .third-party-info.clickable:hover .name {\n  text-decoration: underline;\n}\n\n.BC-Page__Integration .BC-Page__Integration__Content .description {\n  font-size: 14px;\n  color: #637381;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  margin-bottom: 24px;\n  min-height: 40px;\n}\n\n.BC-Page__Integration .BC-Page__Integration__Content .instruction {\n  font-size: 0.75rem;\n  color: #637381;\n  line-height: 1rem;\n  min-height: 48px;\n}\n\n\n.BC-Page__Integration .BC-Page__Integration__Content .btn-configure .Polaris-Button {\n  padding: 3px 12px;\n  min-height: 24px;\n}\n\n.BC-Page__Integration .BC-Page__Integration__Content .btn-submit {\n  margin-top: 12px;\n}\n\n\n.BC-Page__Integration .BC-Page__Integration__Content .BC-Checkbox-Status__Wrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n  min-height: 28px;\n}\n\n.BC-Page__Integration .BC-Page__Integration__Content .BC-Checkbox-Status__Wrapper .BC-Checkbox-Status {\n  margin: 0;\n}\n\n\n.BC-Page__Integration .BC-Page__Integration__Content .BC-Checkbox-Status__Wrapper .Polaris-Badge {\n  background-color: #E0F0FF !important;\n  color: #00527C;\n}\n\n.BC-Page__Integration .BC-Page__Integration__Content .BC-Checkbox-Status__Wrapper .BC-Checkbox-Status {\n  height: 20px;\n  width: 42px;\n}\n\n.BC-Page__Integration .BC-Page__Integration__Content .BC-Checkbox-Status__Wrapper .BC-Checkbox-Status span::before {\n  height: 20px;\n  width: 20px;\n}\n\n.BC-Page__Integration .BC-Page__Integration__Content .BC-Checkbox-Status__Wrapper .BC-Checkbox-Status input:checked + span::before {\n  transform: translateX(8px);\n}\n\n.BC-Page__Integration .BC-Page__Integration__Content .Polaris-FormLayout {\n  margin: 0;\n  margin-bottom: 8px;\n  margin-top: -8px;\n}\n\n.BC-Page__Integration .BC-Page__Integration__Content .Polaris-FormLayout .Polaris-FormLayout__Item {\n  margin: 0;\n}\n\n.BC-Page__Integration .BC-Page__Integration__Pagination {\n  display: flex;\n  justify-content: center;\n  margin-top: 24px;\n}\n\n.reviewsio-banner .Polaris-Link {\n  text-decoration: underline;\n  color: var(--p-interactive);\n}\n\n.BC-ModalAppKey .description {\n  margin-bottom: 16px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
